import React from 'react';
import { FlatTree, Level } from '../../models/api/codegen/code';
import { LiveOrLineType } from '../../store/spirs/types';
import { SportWrapper, ToggleSportProps } from './TreeSport';
import { TreeCategory } from './TreeCategory';
import { TreeFixture } from './TreeFixture';
import { RowComponentProps } from 'react-window';

export type RowProps = {
    visibleLevels: Level[]
    tree: FlatTree
    mode: LiveOrLineType
    toggleSport: ToggleSportProps['toggleSport']
}

export function RowComponent({ index, visibleLevels, tree, mode, toggleSport, style }: RowComponentProps<RowProps>) {
    const level = visibleLevels[index];
    const render = () => {
        switch (level.l) {
            case 'SPORT':
                return <SportWrapper id={level.i} tree={tree} toggleSport={toggleSport} />
            case 'CATEGORY':
                return <TreeCategory id={level.i} tree={tree} />
            case 'FIXTURE':
                return <TreeFixture id={level.i} tree={tree} mode={mode} />
            default:
                return <></>
        }
    }
    return (
        <div style={style}>
            {render()}
        </div>
    )

}